import { useIntl } from 'react-intl';

export type ProjectBudgetFilterValue = {
    currency: string;
    from?: number;
    to?: number;
};

export const useProjectBudgetFilterDescription = (
    filter: ProjectBudgetFilterValue,
): string => {
    const { formatNumber } = useIntl();
    const { currency, from, to } = filter;
    switch (true) {
        case from !== null && to === null:
            return `≥ ${currency} ${formatNumber(from)}`;
        case from === null && to !== null:
            return `≤ ${currency} ${formatNumber(to)}`;
        case from !== null && to !== null:
            return `${currency} ${formatNumber(
                from,
            )} – ${currency} ${formatNumber(to)}`;
        default:
            return '';
    }
};
